import SearchBar from "./SearchBar";
import Content from "./Content";
import { useState } from "react";
import { programData } from "@/data/mentors";

export default function HeroSection() {
  const [results, setResults] = useState(programData);

  return (
    <div className="relative w-full min-h-screen bg-[#FAFAFA] font-sans overflow-x-hidden">
      <div className="absolute top-0 left-0 w-full z-0 h-44 sm:h-56 md:h-72 overflow-hidden pointer-events-none">
        <img
          src="/Mentor/screen 3.png"
          alt="Decoration"
          className="w-full h-full object-cover object-center opacity-50 md:opacity-100"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-8 md:pt-14 pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-12">
            <div className="flex w-full flex-col items-center text-center space-y-8">
              <div className="flex flex-col items-center space-y-2 w-full">
                <h1 className="text-4xl md:text-6xl text-center font-semibold text-black leading-tight tracking-tight mb-3">
                  Learn From the Best
                </h1>

                <p className="text-base sm:text-lg lg:text-xl text-gray-800 font-light w-full sm:w-3/4 lg:w-3/5 leading-relaxed">
                  Learn with experienced, certified tutors who understand that
                  every learner has different goals, needs, and ways of
                  learning. Find the right tutor to guide your Indonesian
                  journey.
                </p>
              </div>

              <SearchBar onResults={setResults} />
            </div>
            <Content results={results} />
          </div>
        </div>
      </div>
    </div>
  );
}
